import React from 'react'

const Home = () => {
    return (
        <section className="home section" id="home">
            <div className="home__container container grid">
                <div className="home__content grid">
                    <div className="home__social">
                        <a href="https://www.linkedin.com/in/sahobisoa-rolland-andrianiaina-317b77181/" target="_blank" className="home__social-icon">
                            <i className="uil uil-linkedin-alt"></i>
                        </a>
                        <a href="https://www.facebook.com/ansaroll.sa/" target="_blank" className="home__social-icon">
                            <i className="uil uil-facebook"></i>
                        </a>
                        <a href="https://github.com/ansaroll" target="_blank" className="home__social-icon">
                            <i className="uil uil-github-alt"></i>
                        </a>
                    </div>

                    <div className="home__img hover:animate-pulse">
                        <img className="home__blob-img" width="100%" src="./assets/meprofil.png" loading="lazy"/>
                    </div>
                    <div className="home__data">
                        <h2>Hi, I'm</h2>
                        <h1 className="home__title">
                            AnSaRoll
                        </h1>
                        <h3 className="home__subtitle">
                            React developer
                        </h3>
                        <p className="home__description">
                            Andrianiaina Sahobisoa Rolland.
                            This site is not yet 100% ready , especially its content . Please be kind 😊 .
                            And if you have any questions or suggestions, please contact me.
                        </p>
                        <a href="#contact" className="button button--flex">
                            Contact Me  <i className="uil uil-message button__icon"></i>
                        </a>
                    </div>

                </div>


                <div className="home__scroll">
                    <a href="#about" className="home__scroll-button button--flex">
                        <i className="uil uil-mouse-alt home__scroll-mouse"></i>
                        <span className="home__scroll-name">Scroll down</span>
                        <i className="uil uil-arrow-down"></i>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default Home
